import React, { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import { testimonials as mockTestimonials } from '../mock';
import { getTestimonials } from '../api';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const Testimonials = () => {
  const { t, pick, lang } = useLang();
  const [idx, setIdx] = useState(0);
  const [testimonials, setTestimonials] = useState(mockTestimonials);

  useEffect(() => {
    getTestimonials().then((d) => d && d.length && setTestimonials(d)).catch(() => {});
  }, []);

  const cur = testimonials[idx];
  const next = () => setIdx((i) => (i + 1) % testimonials.length);
  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 spot-light-emerald pointer-events-none" />
      <div className="max-w-6xl mx-auto px-6 lg:px-10 relative">
        <div className="text-center mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#2563eb] mb-4">— {t('home.testimonials_sub')} —</div>
          <h2 className="font-display text-4xl md:text-5xl text-[#0a0a0a]">{t('home.testimonials_title')}</h2>
        </div>

        <div className="glass-card rounded-2xl p-10 md:p-14 relative">
          <Quote className={`absolute top-8 ${lang === 'ar' ? 'right-8' : 'left-8'} w-16 h-16 text-[#2563eb]/15`} />
          <div className="relative z-10 text-center">
            <div className="flex items-center justify-center gap-1 mb-6">
              {Array.from({ length: cur.rating }).map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#3b82f6] text-[#3b82f6]" />
              ))}
            </div>
            <p className="font-display text-2xl md:text-3xl leading-relaxed text-[#111827]/90 max-w-3xl mx-auto">
              &ldquo;{pick(cur.quote)}&rdquo;
            </p>
            <div className="mt-8 flex items-center justify-center gap-4">
              <img src={cur.avatar} alt={pick(cur.name)} className="w-14 h-14 rounded-full object-cover border-2 border-[#2563eb]/30" />
              <div className="text-left rtl:text-right">
                <div className="font-medium text-[#0a0a0a]">{pick(cur.name)}</div>
                <div className="text-xs text-[#111827]/60 mt-0.5">{pick(cur.role)}</div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mt-10">
            <button onClick={prev} className="w-10 h-10 rounded-full border border-[#2563eb]/30 flex items-center justify-center text-[#2563eb] hover:bg-[#2563eb]/10 transition-colors">
              <ChevronLeft className="w-4 h-4 rtl:hidden" />
              <ChevronRight className="w-4 h-4 hidden rtl:block" />
            </button>
            <div className="flex gap-1.5">
              {testimonials.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} className={`h-1.5 transition-all rounded-full ${i === idx ? 'w-8 bg-[#2563eb]' : 'w-1.5 bg-[#2563eb]/30'}`} />
              ))}
            </div>
            <button onClick={next} className="w-10 h-10 rounded-full border border-[#2563eb]/30 flex items-center justify-center text-[#2563eb] hover:bg-[#2563eb]/10 transition-colors">
              <ChevronRight className="w-4 h-4 rtl:hidden" />
              <ChevronLeft className="w-4 h-4 hidden rtl:block" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
